// Canonical allowlist of post-media content types. Server write-side zod
// schemas (PostMediaInput, PresignPostMediaRequest, FinalizePostMediaRequest)
// enum against this list; the composer narrows browser `File.type` strings
// against it before they become a staged upload.
export const POST_MEDIA_CONTENT_TYPES = [
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/gif',
    'image/heic',
    'image/heif',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
/** Runtime narrowing for an arbitrary string (browser `File.type`, a value
 *  read back from localStorage) down to `PostMediaContentType`. */
export function isPostMediaContentType(value) {
    return POST_MEDIA_CONTENT_TYPES.includes(value);
}
//# sourceMappingURL=post-media.js.map